import { api } from './api';

export interface ScimTokenSummary {
  id: string;
  displayName: string;
  createdAt: string;
}

export interface MintedToken {
  id: string;
  token: string;
  note: string;
}

export const scimApi = {
  async list(companyId: string): Promise<ScimTokenSummary[]> {
    const r = await api.get<ScimTokenSummary[]>(`/api/companies/${companyId}/scim-tokens`);
    return r.data;
  },
  async mint(companyId: string, displayName: string): Promise<MintedToken> {
    const r = await api.post<MintedToken>(`/api/companies/${companyId}/scim-tokens`, { displayName });
    return r.data;
  },
  async revoke(companyId: string, tokenId: string): Promise<void> {
    await api.delete(`/api/companies/${companyId}/scim-tokens/${tokenId}`);
  },
  endpointUrl(): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/scim/v2`;
  },
};
